export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  loadingBtn: (state) => {
    return state.loadingBtn;
  },
  loadBtn: (state) => {
    return state.loadBtn;
  },

  searchList: (state) => {
    return state.searchList;
  },
  searchOpetions: (state) => {
    const searchOpetions = [];
    state.searchList.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      searchOpetions.push(pushItem);
    }
    return searchOpetions;
  },
};
